import React from "react";
import { useHistory } from "react-router-dom";
import { ButtonProps, CommandBarButton } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../core/security/SprintAccessRight";
import { createOrderFormRoute } from "../../OrdersRoutes";

export const AddOrderButton: React.FC<ButtonProps> = (props: ButtonProps) => {
    const history = useHistory();
    const { disabled } = props;

    const handleClick = () => {
        history.push(createOrderFormRoute.path);
    };

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.OrdReadWrite]}>
            <CommandBarButton
                onClick={handleClick}
                text="Add"
                icon="Add"
                disabled={disabled}
                testId="create-order-button"
            />
        </AuthorizationWrapper>
    );
};
